import { createPortal } from "react-dom";
import "../../css/BottomDrawer.css";

function BottomDrawer(props) {
  const { show, styles = {} } = props;
  return createPortal(
    <div
      className={`bottom-drawer ${show ? "drawer-show" : ""}`}
      style={{
        height: styles?.height ? styles?.height : "100dvh",
        ...styles,
      }}
    >
      {props.children}
    </div>,
    document.body,
  );
}

export default BottomDrawer;
